export const defaultEdgeConfig = () => ({
    width: 2,
    color: {
      color: "#76767C",
      highlight: "#DBDBDC",
    },
  });
